<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import App from './App.vue';
const DentalShell = defineAsyncComponent(() => import('@/src/dental/DentalApp.vue'));
const dental = window.location.pathname.startsWith('/app');
</script>

<template>
  <DentalShell v-if="dental" />
  <App v-else />
</template>
